module.exports = __webpack_public_path__ + "static/media/portrait.fe35d095.jpg";